<template>
  <thead>
    <table-tr v-for="(row, rowIndex) in rows" :key="'table-head-row-' + rowIndex" :data="row" />
  </thead>
</template>

<script>
import TableTr from './tr'
export default {
  name: 'TableThead',
  components: { TableTr },
  props: {
    rows: {
      default: () => [],
      required: false,
      type: Array
    }
  }
}
</script>
